import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CartModuleConsts } from '../contants';


@Injectable({
  providedIn: 'root'
})
export class CartService {

  mangentoUrl = environment.apiURL
  constructor(private http: HttpClient) { }

  getBackInStockProducts(data):Observable<any> {
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/backInStockProducts`, data);
  }
  getOutOfStocks(obj):Observable<any> {
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/getOutOfStocks`, obj);
  }

  savecardList():Observable<any>{
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/savecardList`, {});
  }

  removeSaveCard(data):Observable<any>{
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/removeSaveCard`, data);
  }

  getMiniCartItems():Observable<any> {
    return this.http.post<any>(`${this.mangentoUrl}rest/V3/getMiniCartItems`, {});
  }
  getCartItems(obj):Observable<any> {
    return this.http.post<any>(`${this.mangentoUrl}rest/V2/getCartItems`, obj);
  }

  getRecommendedItems():Observable<any> {
    return this.http.post<any>(`${this.mangentoUrl}rest/V3/getRecommendedItems`, {});
  }

  getSalesRepCartItems(obj):Observable<any> {
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/getSalesRepCartItems`, obj);
  }
  addToCartBackInStock(obj):Observable<any>{
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/addToCartBackInStock`, obj);
  }

  removeItem(obj):Observable<any>{
    return this.http.post<any>(`${this.mangentoUrl}rest/V2/removeItem`, obj);
  }

  removeMinicartItem(obj):Observable<any>{
    return this.http.post<any>(`${this.mangentoUrl}rest/V3/removeMiniCartItem`, obj);
  }

  checkoutDetail():Observable<any>{
    return this.http.post<any>(`${this.mangentoUrl}rest/V2/checkoutDetail`, {});
  }

  clearCart(obj):Observable<any>{
    return this.http.post<any>(`${this.mangentoUrl}rest/V2/clearCart`, obj);
  }

  clearMiniCart(obj):Observable<any>{
    return this.http.post<any>(`${this.mangentoUrl}rest/V3/removeAllMiniCartItems`, obj);
  }

  cartAllProductCount():Observable<any>{
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/cartAllProductCount`, {});
  }

  placeOrder(first_click, flag, token, savecard, before_payment, po_number, check_last_order, card_bin=''):Observable<any>{
    let data;
    if (flag == 'payment_token'){
      data = {"store_id": "" , "website" : 1, 'first_click': first_click, 'gateway_token':'', 'save_card':savecard, 'payment_token':token,
      'before_payment':before_payment, 'card_bin':card_bin }
    }
    else if (flag == 'gateway_token'){
      data = {"store_id": "" , "website" : 1, 'first_click': first_click, 'gateway_token':token,
       'save_card':savecard, 'payment_token':'', 'before_payment':before_payment }
    }
    else{
      data = {"store_id": "" , "website" : 1, 'first_click': first_click, 'gateway_token':'', 'save_card':'', 'payment_token':'',
      'before_payment':before_payment }
    }

    if(po_number){
      data['po_number'] = po_number
    }
    data['check_last_order']=check_last_order
    data['bi_tracking_identifier'] = CartModuleConsts.BI_TRACKING_IDENTIFIER_TOPLACEORDER
    return this.http.post<any>(`${this.mangentoUrl}rest/V3/placeOrder`,  data);
    
  }

  viewOrders(obj):Observable<any>{
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/viewOrders`, obj);
  }

  getReviewOrder(data):Observable<any> {
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/reviewOrder`, data);
  }

  validate():Observable<any> {
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/validateOrder`, {});
  }
  
}
